import script from "./UmbrellaBulkTemplateManager.vue?vue&type=script&setup=true&lang=js"
export * from "./UmbrellaBulkTemplateManager.vue?vue&type=script&setup=true&lang=js"

import "./UmbrellaBulkTemplateManager.vue?vue&type=style&index=0&id=132f4308&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-132f4308"]])

export default __exports__